import moment from 'moment'

const localStorageInfo = JSON.parse(localStorage.getItem('CiaoCameraApp'))
if (localStorageInfo && localStorageInfo.app) {
  moment.locale(localStorageInfo.app.langInfo)
}
